import script from "./ButtonDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonDropdown.vue?vue&type=script&setup=true&lang=js"

import "./ButtonDropdown.vue?vue&type=style&index=0&id=0963a3ea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0963a3ea"]])

export default __exports__